module.exports = __webpack_public_path__ + "static/img/image3.49987881.png";